import { useParams } from 'react-router-dom';
import CreateAgentPage from './create-agent';

const EditAgent = () => {
  const { id } = useParams();
  return <CreateAgentPage agentId={id} />;
};

export default EditAgent;
